import { Col, Grid, Layout, Row, Space, Typography } from 'antd';
import { FC } from 'react';
import ECFMGLogo from '../../../shared/logos/ECFMGTag_Full_Color_TM.svg'


const { Title } = Typography;
const { Header } = Layout;
const { useBreakpoint } = Grid;

const HeaderLogoLayout: FC<any> = (_props) => {

  const HeaderLogo = () => {
    const screens = useBreakpoint();
    return (
    <>
    { screens.xs ? (
        <Header
          className="header-logo"
          style={{ alignContent: "center", height: "100%" }}
        >
          <Row style={{ height: "100%", paddingTop: "20px" }}>
            <Col span={24}>
              <Space
                direction={"vertical"}
                size={"small"}
                style={{ alignItems: "center", height: "100%" }}
              >
                <img alt=''
                  src={ECFMGLogo}
                  style={{
                    flex: 1,
                    height: "75%",
                    width: "100%",
                    resize: "block",
                    paddingLeft: 0,
                    float: "left",
                    minHeight: "100px",
                    maxWidth: "350px",
                  }}
                />
                <Title
                  level={1}
                  style={{
                    textAlign: "center",
                    paddingLeft: "0",
                  }}
                >
                  Credential Verification for Health Professionals
                </Title>
              </Space>
            </Col>
          </Row>
        </Header>
      ) : (
        <Header
          className="header-logo"
          style={{ alignContent: "center", height: "100%" }}
        >
          <Row style={{ height: "100%", paddingTop: "10px" }}>
            <Col span={24}>
              <Space
                direction={"horizontal"}
                size={50}
                style={{ alignItems: "center", height: "100%" }}
              >
                <img
                  alt='ECFMG Logo'
                  src={ECFMGLogo}
                  style={{
                    flex: 1,
                    height: "75%",
                    width: "100%",
                    resize: "block",
                    paddingLeft: "25px",
                    float: "left",
                    minHeight: "100px",
                    minWidth: "300px",
                    maxWidth: "350px",
                  }}
                />
                <Title
                  level={1}
                  style={{
                    textAlign: "right",
                    paddingLeft: "20px",
                  }}
                >
                  Credential Verification for Health Professionals
                </Title>
              </Space>
            </Col>
          </Row>
        </Header>
      )}
    </>
    );
  };

  return (
      <HeaderLogo />
  );
};

export default HeaderLogoLayout;